import ReactNativeBiometrics from "react-native-biometrics"

export async function getAvailableSensor() {
  const rnBiometrics = new ReactNativeBiometrics()
  const { available, biometryType } = await rnBiometrics.isSensorAvailable()

  if (!available) {
    return undefined
  }

  return biometryType
}
